var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.38125 7.88281L7.5875 4.67656L6.99688 4.1L4.42344 6.67344L3.00312 5.25312L2.38437 5.87187L4.38125 7.88281ZM5 11.75C3.6875 11.4219 2.60938 10.6602 1.76562 9.46484C0.921875 8.26953 0.5 6.95937 0.5 5.53437V2.1875L5 0.5L9.5 2.1875V5.53437C9.5 6.95937 9.07812 8.26953 8.23438 9.46484C7.39062 10.6602 6.3125 11.4219 5 11.75Z",
    fill: "#6CABE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.b004666c287dd2c9b60808d54f1d7748.svg";
export { ForwardRef as ReactComponent };